import React from 'react';
import { FilledIconContainer, IconContainer } from 'theming/tokens/components/icon';
const WarningIcon = props => {
  if (props.variant === 'filled') {
    return /*#__PURE__*/React.createElement(FilledIconContainer, {
      fill: props.fill,
      size: props.size
    }, /*#__PURE__*/React.createElement("path", {
      d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z"
    }));
  }
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("path", {
    d: "M142.41,40.22l87.46,151.87C236,202.79,228.08,216,215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22C119.89,29.26,136.11,29.26,142.41,40.22Z",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "128",
    y1: "144",
    x2: "128",
    y2: "104",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "128",
    cy: "180",
    r: "12",
    stroke: "none",
    fill: "inherit"
  }));
};
export { WarningIcon };